import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';
import fs from 'fs';
import mkdirp from 'mkdirp';

//utils
import queries from '../../utils/queries'

import HomeGer1 from './homeger1';
import HomeGer2 from './homeger2';

import GerMeta1 from './ger/germeta1';
import GerMeta2 from './ger/germeta2';
import AddMeta1 from './ger/addmeta1';
import AddMeta2 from './ger/addmeta2';
import VerMeta1 from './ger/vermeta1';
import VerMeta2 from './ger/vermeta2';
import GerSegCial1 from './ger/gersegcial1';
import GerSegCial2 from './ger/gersegcial2';
import GerSegLog1 from './ger/gerseglog1';
import GerSegLog2 from './ger/gerseglog2';
import GerSegTras1 from './ger/gersegtras1';
import GerSegTras2 from './ger/gersegtras2';
import GerSegFac1 from './ger/gersegfac1';
import GerSegFac2 from './ger/gersegfac2';
import GerTablero1 from './ger/gertablero1';
import GerTablero2 from './ger/gertablero2';
import GerIndicador1 from './ger/gerindicador1';
import GerIndicador2 from './ger/gerindicador2';
import GerSegTur1 from './ger/gersegtur1';
import GerSegTur2 from './ger/gersegtur2';
import GerIndMes1 from './ger/gerindmes1';
import GerIndMes2 from './ger/gerindmes2';
import GerTribo1 from './ger/gertribo1';
import GerTribo2 from './ger/gertribo2';
import GerProcesosPend1 from './ger/gerprocesospend1';
import GerProcesosPend2 from './ger/gerprocesospend2';
var moment = require('moment');

class HomeGer extends React.Component{
  state={
    showGer: true,
    showMetaCial: false, addMetaCial: false, verMetaCial: false, showTribologia: false,
    showMetaFac: false, addMetaFac: false, verMetaFac: false,
    showMetaUtil: false, addMetaUtil: false, verMetaUtil: false, showIndicadorGer: false, showProcesosPend: false, showIndMes: false,
    showSegCial: false, showSegLog: false, showSegTras: false, showSegFac: false, showTableroGer: false, showSegTur: false, 
    permiteUpdate: false, permiteDelete: false, argsBuscar: {}, argsBuscCoti: {}, argsBuscTur: {},
    argsAdd: {}, errorAdd: [], lista4: [], tipoC: "", lista5: [], lista6: [], listaProg: [],
    idLista: {}, productoI: '', preguntaE: '', respuestaE: 0
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  handleChangeBuscCoti = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar})
    this.handleBuscCoti(argsBuscar)
  }
  handleBuscCoti = async (args) => {
    let argsBuscar={}
    
    if(args.usuarioCreate){
      argsBuscar.usuarioCreate=args.usuarioCreate
    }else{
      delete argsBuscar.usuarioCreate
    } 
    if(args.nombreUsuario){
      argsBuscar.nombreUsuario=args.nombreUsuario
    }else{
      delete argsBuscar.nombreUsuario
    }     
    if(args.nombreUsuarioOC){
      argsBuscar.nombreUsuarioOC=args.nombreUsuarioOC
    }else{
      delete argsBuscar.nombreUsuarioOC
    } 
    if(args.usuarioAutOC){
      argsBuscar.usuarioAutOC=args.usuarioAutOC
    }else{
      delete argsBuscar.usuarioAutOC
    }  
    if(args.numCoti){
      argsBuscar.numCoti=args.numCoti
    }else{
      delete argsBuscar.numCoti
    }
    if(args.numOrdenCompra){
      argsBuscar.numOrdenCompra=args.numOrdenCompra
    }else{
      delete argsBuscar.numOrdenCompra
    }
    if(args.ordenCompraCliente){
      argsBuscar.ordenCompraCliente=args.ordenCompraCliente
    }else{
      delete argsBuscar.ordenCompraCliente
    }    
    if(args.descrEmpresa){
      argsBuscar.descrEmpresa=args.descrEmpresa
    }else{
      delete argsBuscar.descrEmpresa
    }      
    if(args.descrProducto){
      argsBuscar.descrProducto=args.descrProducto
    }else{
      delete argsBuscar.descrProducto
    }
    if(args.estadoOC){
      argsBuscar.estadoOC=args.estadoOC
    }else{
      delete argsBuscar.estadoOC
    }
    if(args.estadoCoti){
      argsBuscar.estadoCoti=args.estadoCoti
    }else{
      delete argsBuscar.estadoCoti
    }

    this.setState({argsBuscCoti: argsBuscar});
  }

  handleChangeBuscTurno = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar})
    this.handleBuscTurno(argsBuscar)
  }
  handleBuscTurno = async (args) => {
    let argsBuscar={}
    
    if(args.nombreUsuario){
      argsBuscar.nombreUsuario=args.nombreUsuario
    }else{
      delete argsBuscar.nombreUsuario
    }     
    if(args.estado){
      argsBuscar.estado=args.estado
    }else{
      delete argsBuscar.estado
    }

    this.setState({argsBuscTur: argsBuscar});
  }

  showGer = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showGer: true})
  }
  
  showMetaCial = (ev) => {
    ev.preventDefault()
    this.props.allMetaRtes.refetch()
    this.estadosFalse()
    this.setState({showMetaCial: true})
  }
  showMetaFac = (ev) => {
    ev.preventDefault()
    this.props.allMetaRtes1.refetch()
    this.estadosFalse()
    this.setState({showMetaFac: true})
  }
  showMetaUtil = (ev) => {
    ev.preventDefault()
    this.props.allMetaRtes2.refetch()
    this.estadosFalse()
    this.setState({showMetaUtil: true})
  }
  showSegCial = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtes.refetch()
    this.estadosFalse()
    this.setState({showSegCial: true})
  }
  showSegLog = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtes.refetch()
    this.estadosFalse()
    this.setState({showSegLog: true})
  }
  showSegTras = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtesTras.refetch()
    this.estadosFalse()
    this.setState({showSegTras: true})
  }
  showSegFac = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtes.refetch()
    this.estadosFalse()
    this.setState({showSegFac: true})
  }
  showTribologia = (ev) => {
    ev.preventDefault()
    // this.props.allMetaRtes.refetch()
    this.estadosFalse()
    this.setState({showTribologia: true})
  }
  showTableroGer = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTableroGer: true})
  }
  showIndicadorGer = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showIndicadorGer: true})
  }
  showProcesosPend = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcesosPend: true})
  }
  showIndMes = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showIndMes: true})
  }
  showSegTur = (ev) => {
    ev.preventDefault()
    this.props.allTurnoRtes.refetch()
    this.estadosFalse()
    this.setState({showSegTur: true})
  }
  addMetaCial = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addMetaCial: true})
  }
  addMetaFac = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addMetaFac: true})
  }
  addMetaUtil = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addMetaUtil: true})
  }

  consultaPlanta = async (args) => {
    let {data} = await this.props.allPlantaRtes1.refetch(args)
    let listaProg = data.allPlantaRtes
    this.setState({listaProg})

  }
  // allAjusteRtes: async (parent, args, {models}) => {
  //   let consultar = `models.Ajuste.aggregate(${args.tipoqry})`
  //   return await eval(consultar)
  // }


  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd
    let datoTipo = ""
    if(input!==undefined&&ev.target.name===undefined){
      datoTipo = input.type
    } 

    if(datoTipo==='checkbox'){
      argsAdd[input.name] = input.checked
    }else{
      if(ev.target.type==='checkbox'){
        argsAdd[ev.target.name] = ev.target.checked
      }else{
        argsAdd[ev.target.name] = ev.target.value
      }
    }
    this.setState({argsAdd});
  }



  handleMeta = async (ev, args)=>{
    if(((!args.agno || args.agno==="Seleccionar..." || !args.mes || args.mes==="Seleccionar...")
        || (!this.state.addMetaUtil && !this.state.verMetaUtil && (!args.nombreUsuario || args.nombreUsuario==="Seleccionar..."))) 
        && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let mesNum = 0
      switch(args.mes){
        case 'Enero':
          mesNum = 1;
          break
        case 'Febrero':
          mesNum = 2;
          break
        case 'Marzo':
          mesNum = 3;
          break
        case 'Abril':
          mesNum = 4;
          break
        case 'Mayo':
          mesNum = 5;
          break
        case 'Junio':
          mesNum = 6;
          break
        case 'Julio':
          mesNum = 7;
          break
        case 'Agosto':
          mesNum = 8;
          break
        case 'Septiembre':
          mesNum = 9;
          break
        case 'Octubre':
          mesNum = 10;
          break
        case 'Noviembre':
          mesNum = 11;
          break
        case 'Diciembre':
          mesNum = 12;
          break
      }

      if(this.state.addMetaCial || this.state.addMetaFac || this.state.addMetaUtil){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        args.valorReal=0
        args.estado='Abierto'
        args.mesNum = mesNum
        args.grupo = args.grupo?args.grupo:''
        if(this.state.addMetaCial){
          args.tipoMeta = 'Comercial'
        }
        if(this.state.addMetaFac){
          args.tipoMeta = 'Facturación'
        }
        if(this.state.addMetaUtil){
          args.tipoMeta = 'Utilidad'
          args.cedula=''
          args.nombreUsuario=''
        }
        response = await this.props.createMeta({
          variables: args
        });
       
        const {errors, success} = response.data.createMeta;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var agno = document.getElementById("miLista");
          agno.options.selectedIndex = 0        
          var mes = document.getElementById("miLista1");
          mes.options.selectedIndex = 0     
          if(args.tipoMeta !== 'Utilidad'){   
          var nombreUsuario = document.getElementById("miLista2");
          nombreUsuario.options.selectedIndex = 0     
          }   
          if(args.tipoMeta === 'Comercial'){
            var valor = document.getElementById("valor");
            valor.value = 0
          }
          var meta = document.getElementById("meta");
          meta.value = 0
          var metaAgno = document.getElementById("metaAgno");
          metaAgno.value = 0
          var metaAcumAgno = document.getElementById("metaAcumAgno");
          metaAcumAgno.value = 0
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          if(args.tipoMeta === 'Comercial'){
            this.props.allMetaRtes.refetch()
          }
          if(args.tipoMeta === 'Facturación'){
            this.props.allMetaRtes1.refetch()
          }
          if(args.tipoMeta === 'Utilidad'){
            this.props.allMetaRtes2.refetch()
          }
        }
      }else{
        if(this.state.permiteUpdate){
          var cedula = ''
          var nombreUsuario = ''
          if(args.tipoMeta!=='Utilidad'){
            cedula = args.cedula
            nombreUsuario = args.nombreUsuario
          } 
          const argsUpd = {
            _id: args._id,
            tipoMeta: args.tipoMeta,
            agno: args.agno,
            mes: args.mes,
            mesNum: mesNum,
            grupo: args.grupo?args.grupo:'',
            cedula: cedula,
            nombreUsuario: nombreUsuario,
            valor: args.valor?args.valor:0,
            meta: args.meta?args.meta:0,
            valorReal: args.valorReal?args.valorReal:0,
            estado: args.estado,
            metaAgno: args.metaAgno?args.metaAgno:0,
            metaAcumAgno: args.metaAcumAgno?args.metaAcumAgno:0,
          }



          const response = await this.props.editMeta({
            variables: argsUpd
          });
          const {errors, success} = response.data.editMeta;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.estadosFalse()
            if(args.tipoMeta==='Comercial'){
              this.props.allMetaRtes.refetch()
              this.setState({showMetaCial: true})
            }
            if(args.tipoMeta==='Facturación'){
              this.props.allMetaRtes1.refetch()
              this.setState({showMetaFac: true})
            }
            if(args.tipoMeta==='Utilidad'){
              this.props.allMetaRtes2.refetch()
              this.setState({showMetaUtil: true})
            }
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteMeta({
            variables: argsDel
          });
          
          this.estadosFalse()
          if(args.tipoMeta==='Comercial'){
            this.props.allMetaRtes.refetch()
            this.setState({showMetaCial: true})
          }
          if(args.tipoMeta==='Facturación'){
            this.props.allMetaRtes1.refetch()
            this.setState({showMetaFac: true})
          }
          if(args.tipoMeta==='Utilidad'){
            this.props.allMetaRtes2.refetch()
            this.setState({showMetaUtil: true})
          }
        }
      }
    }
  }



  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleSelAgno = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['agno'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelMes = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['mes'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }
  handleSelGrupo = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['grupo'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelEstado = () => {
    var miLista1 = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['miLista1'] = miLista1.options[miLista1.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelnombreUsuario = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreUsuario'] = miLista.options[miLista.selectedIndex].text
    argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['ciudad'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['email'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['telefono'] = miLista.options[miLista.selectedIndex].attributes[3].value

    this.setState({argsAdd});
  } 


  crudBD = async (operacionCRUD, args)=>{
//ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
//ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0])
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0])
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i])
    }
  }

  idLista = async (ev, idLista)=>{
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showMetaCial) {
      this.setState({verMetaCial: true})
    }
    if (this.state.showMetaFac) {
      this.setState({verMetaFac: true})
    }
    if (this.state.showMetaUtil) {
      this.setState({verMetaUtil: true})
    }
  };
  
  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  render(){
    const {showGer, showMetaCial, addMetaCial, verMetaCial, showMetaFac, addMetaFac, verMetaFac, showIndicadorGer, showProcesosPend, showIndMes, showSegTur, 
      showMetaUtil, addMetaUtil, verMetaUtil, showSegCial, showSegLog, showSegTras, showSegFac, showTableroGer, showTribologia, argsBuscCoti, argsBuscar,
      argsBuscTur, permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista, errors, listaProg} = this.state;        

    let lista = []
    let lista1 = []
    let lista2 = []
    let lista3 = []
    let listaE = []
    let lista22 = []
    let listaItem = []
    let lista11 = []


    if (this.state.showMetaCial) {
      if(this.props.allMetaRtes.allMetaRtes){lista = this.props.allMetaRtes.allMetaRtes}
    }
    if (this.state.showMetaFac) {
      if(this.props.allMetaRtes1.allMetaRtes){lista = this.props.allMetaRtes1.allMetaRtes}
    }
    if (this.state.showMetaUtil) {
      if(this.props.allMetaRtes2.allMetaRtes){lista = this.props.allMetaRtes2.allMetaRtes}
    }

    if (this.state.addMetaCial || this.state.verMetaCial || this.state.addMetaFac || this.state.verMetaFac) {
      if(this.props.allUsuariosRtes.allUsuariosRtes){lista = this.props.allUsuariosRtes.allUsuariosRtes}
    }
    if (this.state.showTribologia) {
      let programacion = []
      let listaReg = {}
      let listaProg = this.props.allPlantaRtesProg.allPlantaRtes
      // console.log(listaProg)
      let empresas = this.props.allEmpresa.allEmpresa
      let listaRutas = this.props.allOrdenRtes.allOrdenRtes
      let listaOrdenes = this.props.allOrdenRtes1.allOrdenRtes
      let listaHallazgos = this.props.allOrdenRtes2.allOrdenRtes

      empresas = empresas.filter(elemento => (elemento.rutas==='S'))
      empresas.forEach(async (elemento, i) => {
        programacion = listaProg.filter(prog => (prog.descrEmpresa===elemento.descrEmpresa))



        // let argsBuscar = {}
        // argsBuscar = `'descrEmpresa': '${elemento.descrEmpresa}'`
        // let argsBuscarPl = {}
        // let argsQuery = `{"$unwind": "$secciones"},
        // {"$unwind": "$secciones.equipos"},
        // {"$unwind": "$secciones.equipos.componentes"},
        // {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        // {$project: {_id: 1, programacion: {
        //     $let: {
        //       vars: {regProg: { $cond: { if: { $isArray: "$secciones.equipos.componentes.mecanismos.programacion" },
        //                                     then: { $size: "$secciones.equipos.componentes.mecanismos.programacion" },
        //                                     else: 0} }
        //       },
        //       in: { $cond: { if: { $gt: [ "$$regProg", 0 ] },
        //                           then: "$secciones.equipos.componentes.mecanismos.programacion",
        //                           else: [{descrTarea: null, fechaProx: null, acumProx: 0, enRuta: null, activo: null}] } }
        //     }
        //   },
        //   descrEmpresa: 1, tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia'}},
        // {"$unwind": "$programacion"},
        // {$project: {_id: 1, descrEmpresa: 1, tipoFrecuencia: 1, descrTarea: '$programacion.descrTarea', fechaProx: '$programacion.fechaProx', acumProx: '$programacion.acumProx', enRuta: '$programacion.enRuta', activo: '$programacion.activo', 
        //   numCarta: {
        //     $let: {
        //       vars: {fechaProxDif: '$programacion.fechaProx'},
        //     in: {$cond: [
        //       {
        //         "$or":[
        //           { "$eq": [ "$$fechaProxDif", null ] },
        //           { "$eq": [ "$$fechaProxDif", '' ]},
        //         ]
        //       }, 
        //       1,
        //       { $toInt: {$divide: [{$subtract: [ new Date(), {"$toDate": '$$fechaProxDif'} ]}, 86400000 ]}}
        //       ]
        //     }}
        //   },
        //   ultInforme: {
        //     $let: {
        //       vars: {acumProxDif: { $subtract: [ "$acumulado", "$acumProx" ]}},
        //       in: {$cond: [
        //         {
        //           "$or":[
        //           { "$eq": [ "$$acumProxDif", null ] },
        //           { "$eq": [ "$$acumProxDif", '' ]},
        //           ]
        //         }, 
        //         1,
        //         { $toInt: {$divide: ["$$acumProxDif", 1 ]}}
        //       ]
        //     }
        //     }
        //   }
        // }},
        // {$match: {'descrTarea': {$ne: null}, 'enRuta': {$in: ['N', '', null]}, 'activo': {$in: ['S', '', null]}}},
        // {$project: {_id: 1, descrEmpresa: 1, tipoFrecuencia: 1, numCarta: 1, ultInforme: 1}}`
        // argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${argsQuery}]`}

        // this.consultaPlanta(argsBuscarPl)
        
        
 
        // if(this.state.listaProg.length>0){
        //   programacion=this.state.listaProg
        // }

        let rutas = listaRutas.filter(ruta => (ruta.descrEmpresa===elemento.descrEmpresa))
        let hallazgos = listaHallazgos.filter(hallazgo => (hallazgo.descrEmpresa===elemento.descrEmpresa))
        rutas.forEach((elemento1, ii) => {
          let ordenes1 = listaOrdenes.filter(orden => (orden.ruta===parseInt(elemento1.ruta)))
          let programadas=ordenes1.length
          let reportadas=0, ejecutadas=0, porcEjec=0, pendientes=0, porcRep=0, ideal=0
          let bandera='flag green icon'
          let creadaEn='', creadaPor=''
          ordenes1.forEach((elemento2, iii) => {
            let numDiasProg = moment(new Date(), 'YYYY-MM-DD').diff(moment(elemento2.fechaProg, 'YYYY-MM-DD'), 'days')
            if(parseInt(numDiasProg)>0){
              ideal+=1
            }
            if(elemento2.alimSistema==='S'){
              if(elemento2.realizado==='S'){
                ejecutadas+=1
              }
              reportadas+=1
            }else{
              pendientes+=1
            }
            creadaEn=elemento2.fechaCreate
            creadaPor=elemento2.usuarioCreate
          })
          ideal=parseInt((ideal*100)/programadas)
          porcRep=parseInt((reportadas*100)/programadas)
          porcEjec=parseInt((ejecutadas*100)/programadas)
          if(porcEjec<ideal){
            bandera='flag red icon'
          }
          listaReg = {
            "empresa": elemento.descrEmpresa,
            "ruta": elemento1.ruta,
            "creadaEn": creadaEn,
            "creadaPor": creadaPor,
            "programadas": programadas,
            "reportadas": reportadas,
            "pendientes": pendientes,
            "porcRep": porcRep,
            "ideal": ideal,
            "ejecutadas": ejecutadas,
            "porcEjec": porcEjec,
            "vigentes": '',
            "vencidas": '',
            "bandera": bandera,
          }
          lista.push(listaReg)
          listaReg={}
        })
        if(hallazgos.length>0){
          let programadas=0, reportadas=0, ejecutadas=0, porcEjec=0, pendientes=0, porcRep=0
          let bandera='flag green icon'
          hallazgos.forEach((elemento3, iii) => {
            programadas+=elemento3.acumReal
            if(elemento3.alimSistema==='S'){
              if(elemento3.realizado==='S'){
                ejecutadas+=elemento3.acumReal
              }
              reportadas+=elemento3.acumReal
            }else{
              pendientes+=elemento3.acumReal
            }
          })
          porcRep=parseInt((reportadas*100)/programadas)
          porcEjec=parseInt((ejecutadas*100)/programadas)
          if(porcEjec<programadas){
            bandera='flag red icon'
          }
          listaReg = {
            "empresa": elemento.descrEmpresa,
            "ruta": 'Hallazgos',
            "creadaEn": '',
            "creadaPor": '',
            "programadas": programadas,
            "reportadas": reportadas,
            "pendientes": pendientes,
            "porcRep": porcRep,
            "ideal": 0,
            "ejecutadas": ejecutadas,
            "porcEjec": porcEjec,
            "vigentes": '',
            "vencidas": '',
            "bandera": bandera,
          }
          lista.push(listaReg)
          listaReg={}
        }
console.log(programacion)
        if(programacion.length>0){
          let vencidas=0, vigentes=0
          let bandera='flag green icon'
          programacion.forEach((elemento4, iii) => {
            if(elemento4.tipoFrecuencia==='Calendario'){ 
              if(elemento4.numCarta!=='' && elemento4.numCarta!==null){
                if(elemento4.numCarta>=0){
                  vencidas+= 1
                }else{
                  vigentes+= 1
                }
              }
            }else{
              if(elemento4.ultInforme!=='' && elemento4.ultInforme!==null){
                if(elemento4.ultInforme>=0){
                  vencidas+= 1
                }else{
                  vigentes+= 1
                }
              }
            }
          })
          if(vencidas>0){
            bandera='flag red icon'
          }
          listaReg = {
            "empresa": elemento.descrEmpresa,
            "ruta": 'No programadas',
            "creadaEn": '',
            "creadaPor": '',
            "programadas": '',
            "reportadas": '',
            "pendientes": '',
            "porcRep": '',
            "ideal": '',
            "ejecutadas": '',
            "porcEjec": '',
            "vigentes": vigentes,
            "vencidas": vencidas,
            "bandera": bandera,
          }
          // console.log(listaReg)
          lista.push(listaReg)
          listaReg={}
        }
      })
    }
    let fechaFin = new Date()
    fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())

    //calcular fechaHoy como 364 dias antes de la fecha actual
    let fechaHoy = parseInt((new Date().getTime() - (1000*60*60*24)*6), 10)
    fechaHoy = new Date(fechaHoy)
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let diasDesde=6, diasHasta=0

    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showGer && <HomeGer1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                          handleClickSel11={this.showMetaCial} handleClickSel12={this.showMetaFac} 
                          handleClickSel13={this.showMetaUtil} handleClickSel14={this.showSegCial}
                          handleClickSel15={this.showSegLog} handleClickSel16={this.showSegFac} 
                          handleClickSel17={this.showTableroGer} handleClickSel18={this.showSegTras} 
                          handleClickSel19={this.showIndicadorGer} handleClickSel20={this.showSegTur}
                          handleClickSel21={this.showIndMes} handleClickSel22={this.showTribologia}
                          handleClickSel23={this.showProcesosPend}/>}

            {showMetaCial && <GerMeta1 styles={this.props.styles} handleClickRegr={this.showGer}/>}
            {showMetaFac && <GerMeta1 styles={this.props.styles} handleClickRegr={this.showGer}/>}
            {showMetaUtil && <GerMeta1 styles={this.props.styles} handleClickRegr={this.showGer}/>}

            {addMetaCial && <AddMeta1 styles={this.props.styles} handleClickRegr={this.showMetaCial}/>}
            {addMetaFac && <AddMeta1 styles={this.props.styles} handleClickRegr={this.showMetaFac}/>}
            {addMetaUtil && <AddMeta1 styles={this.props.styles} handleClickRegr={this.showMetaUtil}/>}

            {verMetaCial && <VerMeta1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showMetaCial} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {verMetaFac && <VerMeta1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showMetaFac} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {verMetaUtil && <VerMeta1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showMetaUtil} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {showSegCial && <GerSegCial1 styles={this.props.styles}
                handleChange={this.handleChangeBuscCoti} handleSubmit={this.handleBuscCoti}
                args={argsBuscar} handleClickRegr={this.showGer}/>}
            {showSegLog && <GerSegLog1 styles={this.props.styles}
                handleChange={this.handleChangeBuscCoti} handleSubmit={this.handleBuscCoti}
                args={argsBuscar} handleClickRegr={this.showGer}/>}
            {showSegTras && <GerSegTras1 styles={this.props.styles}
                handleChange={this.handleChangeBuscCoti} handleSubmit={this.handleBuscCoti}
                args={argsBuscar} handleClickRegr={this.showGer}/>}
            {showSegFac && <GerSegFac1 styles={this.props.styles}
                handleChange={this.handleChangeBuscCoti} handleSubmit={this.handleBuscCoti}
                args={argsBuscar} handleClickRegr={this.showGer}/>}    
            {showTribologia && <GerMeta1 styles={this.props.styles} handleClickRegr={this.showGer}/>}
            {showTableroGer && <GerTablero1 styles={this.props.styles} handleClickRegr={this.showGer}/>}    
            {showIndicadorGer && <GerIndicador1 styles={this.props.styles} handleClickRegr={this.showGer}/>}   
            {showSegTur && <GerSegTur1 styles={this.props.styles}
                handleChange={this.handleChangeBuscTurno} handleSubmit={this.handleBuscTurno}
                args={argsBuscar} handleClickRegr={this.showGer}/>} 
            {showIndMes && <GerIndMes1 styles={this.props.styles} handleClickRegr={this.showIndMes}/>}
            {showProcesosPend && <GerProcesosPend1 styles={this.props.styles} handleClickRegr={this.showGer}/>}   

          </div>
         
          <div className="column" style={this.props.styles.boxDer}>
            {showGer && <HomeGer2 styles={this.props.styles}/>}

            {showMetaCial && <GerMeta2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} metaTipo="Comercial"
                handleClick={this.addMetaCial} list={lista} handleClickidLista={this.idLista}/>}
            {showMetaFac && <GerMeta2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} metaTipo="Facturación"
                handleClick={this.addMetaFac} list={lista} handleClickidLista={this.idLista}/>}
            {showMetaUtil && <GerMeta2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} metaTipo="Utilidad"
                handleClick={this.addMetaUtil} list={lista} handleClickidLista={this.idLista}/>}    
            {addMetaCial && <AddMeta2 styles={this.props.styles} list={lista} metaTipo="Comercial"
                handleLista1={this.handleSelAgno} handleLista2={this.handleSelMes} handleLista3={this.handleSelnombreUsuario}
                handleLista4={this.handleSelGrupo}
                handleSubmit={this.handleMeta} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {addMetaFac && <AddMeta2 styles={this.props.styles} list={lista} metaTipo="Facturación"
                handleLista1={this.handleSelAgno} handleLista2={this.handleSelMes} handleLista3={this.handleSelnombreUsuario}
                handleLista4={this.handleSelGrupo}
                handleSubmit={this.handleMeta} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {addMetaUtil && <AddMeta2 styles={this.props.styles} list={lista} metaTipo="Utilidad"
                handleLista1={this.handleSelAgno} handleLista2={this.handleSelMes} handleLista3={this.handleSelnombreUsuario}
                handleSubmit={this.handleMeta} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            
            {verMetaCial && <VerMeta2 styles={this.props.styles} list={lista} handleSubmit={this.handleMeta} metaTipo="Comercial"
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}
            {verMetaFac && <VerMeta2 styles={this.props.styles} list={lista} handleSubmit={this.handleMeta} metaTipo="Facturación"
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}
            {verMetaUtil && <VerMeta2 styles={this.props.styles} list={lista} handleSubmit={this.handleMeta} metaTipo="Utilidad"
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}
            {showSegCial && <GerSegCial2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscCoti={argsBuscCoti} fechaFin={fechaFin} fechaHoy={fechaHoy} 
                handleChange={this.handleChangeBuscCoti} args={argsAdd}/>}
            {showSegLog && <GerSegLog2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscCoti={argsBuscCoti} fechaFin={fechaFin} fechaHoy={fechaHoy} 
                handleChange={this.handleChangeBuscCoti} args={argsAdd}/>}
            {showSegTras && <GerSegTras2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscCoti={argsBuscCoti} fechaFin={fechaFin} fechaHoy={fechaHoy} 
                handleChange={this.handleChangeBuscCoti} args={argsAdd}/>}
            {showSegFac && <GerSegFac2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscCoti={argsBuscCoti} fechaFin={fechaFin} fechaHoy={fechaHoy} 
                handleChange={this.handleChangeBuscCoti} args={argsAdd} diasDesde={diasDesde} diasHasta={diasHasta}/>}   
            {showTribologia && <GerTribo2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} list={lista}/>}
            {showTableroGer && <GerTablero2 styles={this.props.styles}/>} 
            {showIndicadorGer && <GerIndicador2 styles={this.props.styles}/>} 
            {showSegTur && <GerSegTur2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscTur={argsBuscTur} fechaFin={fechaFin} fechaHoy={fechaHoy} 
                handleChange={this.handleChangeBuscTurno} args={argsAdd}/>}
            {showIndMes && <GerIndMes2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
            {showProcesosPend && <GerProcesosPend2 styles={this.props.styles}/>} 
          </div>
        </div> 
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtesProg',
    options: (props) => {return {variables: {tipoqry: `[{$project: {_id: 1, descrEmpresa: 1, secciones: 1}},
    {$lookup: {from: 'empresas', localField: 'descrEmpresa', foreignField: 'descrEmpresa', as: 'empresa'}},
    {$unwind: '$empresa'},
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: '$empresa.rutas', secciones: 1}},
    {$match: {'descrPlanta': 'S'}},
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: '$empresa.rutas', secciones: 1}},
    {"$unwind": "$secciones"},
    {"$unwind": "$secciones.equipos"},
    {"$unwind": "$secciones.equipos.componentes"},
    {"$unwind": "$secciones.equipos.componentes.mecanismos"},
    {$project: {_id: 1, programacion: {
        $let: {
          vars: {regProg: { $cond: { if: { $isArray: "$secciones.equipos.componentes.mecanismos.programacion" },
                                        then: { $size: "$secciones.equipos.componentes.mecanismos.programacion" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regProg", 0 ] },
                              then: "$secciones.equipos.componentes.mecanismos.programacion",
                              else: [{descrTarea: null, fechaProx: null, acumProx: 0, enRuta: null, activo: null}] } }
        }
      },
      descrEmpresa: 1, tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia'}},
    {"$unwind": "$programacion"},
    {$project: {_id: 1, descrEmpresa: 1, tipoFrecuencia: 1, descrTarea: '$programacion.descrTarea', fechaProx: '$programacion.fechaProx', acumProx: '$programacion.acumProx', enRuta: '$programacion.enRuta', activo: '$programacion.activo', 
      numCarta: {
        $let: {
          vars: {fechaProxDif: '$programacion.fechaProx'},
         in: {$cond: [
           {
             "$or":[
              { "$eq": [ "$$fechaProxDif", null ] },
              { "$eq": [ "$$fechaProxDif", '' ]},
             ]
           }, 
           1,
           { $toInt: {$divide: [{$subtract: [ new Date(), {"$toDate": '$$fechaProxDif'} ]}, 86400000 ]}}
          ]
        }}
      },
      ultInforme: {
        $let: {
          vars: {acumProxDif: { $subtract: [ "$acumulado", "$acumProx" ]}},
          in: {$cond: [
            {
              "$or":[
               { "$eq": [ "$$acumProxDif", null ] },
               { "$eq": [ "$$acumProxDif", '' ]},
              ]
            }, 
            1,
            { $toInt: {$divide: ["$$acumProxDif", 1 ]}}
           ]
         }
        }
      }
    }},
    {$match: {'descrTarea': {$ne: null}, 'enRuta': {$in: ['N', '', null]}, 'activo': {$in: ['S', '', null]}}},
    {$project: {_id: 1, descrEmpresa: 1, tipoFrecuencia: 1, numCarta: 1, ultInforme: 1}}
    ]`}}}}),

  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),


  graphql(queries.query.allMetaRtes, {name:'allMetaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: 'Comercial'}}, {$sort: {agno: -1, mes: -1}}]`}}}}),
  graphql(queries.query.allMetaRtes, {name:'allMetaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: 'Facturación'}}, {$sort: {agno: -1, mes: -1}}]`}}}}),
  graphql(queries.query.allMetaRtes, {name:'allMetaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: 'Utilidad'}}, {$sort: {agno: -1, mes: -1}}]`}}}}),
  graphql(queries.query.allTurnoRtes, {name:'allTurnoRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estado: {$ne: 'XXX'}}}, {$sort: {fechaHoraIniTurno: -1}}]`}}}}),
  
  graphql(queries.mutation.createMeta, {name:'createMeta'}),
  graphql(queries.mutation.editMeta, {name:'editMeta'}),
  graphql(queries.mutation.deleteMeta, {name:'deleteMeta'}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: {$ne: 'Externo'}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Externo'}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Comercial'}}]`}}}}),

  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.encriptar, {name:'encriptar'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesTras',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estadoOrden: 'Abierto', $or: [
      { 'descrMetodo': {$ne: 'Hallazgo'}},
      { 'descrMetodo': 'Hallazgo', 'descrTarea': 'Tomar muestra'}
    ]}}, 
    {$project: {descrEmpresa: 1, ruta: {"$toString": "$ruta"}}},
    {$group: {_id: {ruta: '$ruta', descrEmpresa: '$descrEmpresa'}}},
      {$project: {_id:{$concat: ["$_id.ruta", "$_id.descrEmpresa"]}, ruta: '$_id.ruta', descrEmpresa: '$_id.descrEmpresa'}},
    {$sort: {descrEmpresa: 1, ruta: 1}}]`}}}}),

  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoOrden': 'Abierto'}},
    {$project: {ruta: 1, numeroOrden: 1, fechaProg: 1, fechaReal: 1, fechaCreate: 1, usuarioCreate: 1, descrEmpresa: 1, estadoOrden: 1, realizado: 1, alimSistema: 1}}]`}}}}),

  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estadoOrden: 'Abierto', 'descrMetodo': 'Hallazgo', 'descrTarea': {$ne: 'Tomar muestra'}}}, 
    {$project: {descrEmpresa: 1, alimSistema: 1, realizado: 1}},
    {$group: {_id: {descrEmpresa: '$descrEmpresa', alimSistema: '$alimSistema', realizado: '$realizado'}, count: {$sum: 1}}},
      {$project: {_id:{$concat: ["$_id.descrEmpresa", "$_id.alimSistema", "$_id.realizado"]}, 
      descrEmpresa: '$_id.descrEmpresa', alimSistema: '$_id.alimSistema', realizado: '$_id.realizado', acumReal: {$toInt: '$count'}}},
    {$sort: {descrEmpresa: 1}}]`}}}}),


)(HomeGer)
